<template>
  <div class="secondaryMenuContainer">
    <el-menu
      v-if="routeName == '消息'"
      :key="keyNew + '消息'"
      :collapse="isCollapse"
      :default-active="defaultactive.path"
      :unique-opened="false"
      :collapse-transition="false"
      style="border: none"
    >
      <div v-for="item of newShowList" :key="item.id">
        <el-menu-item-group>
          <div v-for="(children, index) of item.sub" :key="index">
            <el-submenu v-if="children.sub.length > 0 && children.permissionKey != 'processManagement'" :index="children.name">
              <template slot="title">
                <div class="title_class" @click="clickli(children.sub, item.name)">
                  <img v-if="classObj.hideSidebar == true && queshow(children) && children.icon1" :src="children.icon1" alt="图片" class="notActive" />
                  <img v-else-if="children.icon2" :src="children.icon2" alt="图片" class="activation" />
                </div>
                <span v-if="!classObj.hideSidebar" :title="children.name">{{ children.name }}</span>
              </template>
              <template>
                <el-menu-item
                  v-for="sub2 of children.sub"
                  :key="sub2.path"
                  :index="children.name + '/' + sub2.name"
                  :title="sub2.name"
                  style="min-width: 110px"
                  @click="goNext(sub2)"
                >
                  {{ sub2.name }}
                </el-menu-item>
              </template>
            </el-submenu>
            <el-menu-item v-else :index="children.name" @click="goNext(children)">
              <div class="title_class">
                <img v-if="children.name != defaultactive.path && children.icon1" :src="children.icon1" alt="图片" class="notActive" />
                <img v-else-if="children.icon2" :src="children.icon2" alt="图片" class="activation" />
              </div>
              <span v-if="!classObj.hideSidebar" :title="children.name" class="w110">{{ children.name }}</span>
              <div v-if="children.unReadNum && classObj.hideSidebar == false" class="newStyle" :title="children.unReadNum">
                {{ children.unReadNum }}
              </div>
            </el-menu-item>
          </div>
        </el-menu-item-group>
      </div>
    </el-menu>
    <el-menu v-else-if="routeName == '用户中心'" :default-active="defaultactive.path" style="padding-top: var(--middle-space)">
      <div v-for="(item, index) in userRouterList" :key="index">
        <el-menu-item :index="item.name" @click="goNext(item)">
          <div class="title_class">
            <img v-if="item.name != defaultactive.path && item.icon1" :src="item.icon1" class="notActive" />
            <img v-else-if="item.icon2" :src="item.icon2" class="activation" />
          </div>
          <span v-if="!classObj.hideSidebar" :title="item.name">{{ item.name }}</span>
        </el-menu-item>
      </div>
    </el-menu>
    <el-menu v-else-if="routeName == '个人'" :collapse="isCollapse" :default-active="defaultactive.path" :unique-opened="false" :collapse-transition="false" class="docNav">
      <div v-for="(item, num) of showList" :key="num">
        <el-menu-item-group>
          <div v-for="(children, index) of item.sub" :key="index">
            <el-submenu v-if="children.sub.length > 0 && (children.permissionKey == 'persondoc' || children.permissionKey == 'enterprisedoc')" :index="children.name">
              <template slot="title">
                <div class="title_class" @click="clickli(children.sub, item.name)">
                  <img v-if="classObj.hideSidebar == true && queshow(children)" :src="children.icon2" alt="图片" />
                  <img v-else :src="children.icon1" alt="图片" />
                </div>
                <span v-if="!classObj.hideSidebar" :title="children.name">{{ children.name }}</span>
              </template>
              <el-menu-item
                v-for="sub2 of children.sub"
                :key="sub2.path"
                :index="children.name + '/' + sub2.name"
                :title="sub2.name"
                style="min-width: 110px"
                @click="goNext(sub2)"
              >
                <div>
                  <img :src="folder" alt="图片" style="margin-right: 5px" />
                  <span v-if="!classObj.hideSidebar" class="w110">{{ sub2.name }}</span>
                </div>
              </el-menu-item>
            </el-submenu>
            <el-submenu v-if="children.sub.length > 0 && children.permissionKey == 'enterpriseDeptDoc'" :index="children.name">
              <template slot="title">
                <div class="title_class" @click="clickli(children.sub, item.name)">
                  <img v-if="classObj.hideSidebar == true && queshow(children)" :src="children.icon2" alt="图片" />
                  <img v-else :src="children.icon1" alt="图片" />
                </div>
                <span v-if="!classObj.hideSidebar" :title="children.name">{{ children.name }}</span>
              </template>
              <el-menu-item
                v-for="sub2 of children.sub"
                :key="sub2.path"
                :index="children.name + '/' + sub2.permissionKey"
                :title="sub2.name"
                style="min-width: 110px"
                @click="goNext(sub2)"
              >
                <div class="titleBox">
                  <div>
                    <img :src="folder" alt="图片" />
                    <span v-if="!classObj.hideSidebar" :class="sub2.name === '回收站' ? 'w110' : 'enterpriseDeptDocName'">{{ sub2.name }}</span>
                  </div>
                  <div>
                    <img v-if="sub2.permissionKey !== 'recycle' && updateDoc && !classObj.hideSidebar" :src="editIcon" alt="图片" @click.stop="editDepClass(sub2)" />
                    <img v-if="sub2.permissionKey !== 'recycle' && deleteDoc && !classObj.hideSidebar" :src="delIcon" alt="图片" @click.stop="delDepClass(sub2)" />
                  </div>
                </div>
              </el-menu-item>
            </el-submenu>
          </div>
        </el-menu-item-group>
      </div>
    </el-menu>
    <el-menu v-else :key="routeName" :collapse="isCollapse" :default-active="defaultactive.path" :unique-opened="false" :collapse-transition="false" style="border: none">
      <div v-for="(item, num) of showList" :key="num">
        <el-menu-item-group>
          <div v-for="(children, index) of item.sub" :key="index">
            <el-submenu
              v-if="children.sub.length > 0 && children.permissionKey != 'processManagement' && children.sub.length > 0 && children.permissionKey != 'setup'"
              :index="children.name"
            >
              <template slot="title">
                <div class="title_class" @click="clickli(children.sub, item.name)">
                  <img v-if="classObj.hideSidebar == true && queshow(children)" :src="children.icon2" alt="图片" class="activation" />
                  <img v-else-if="children.icon1" :src="children.icon1" alt="图片" class="notActive" />
                  <img v-else :src="noIcon" alt="图片" />
                  <span>1</span>
                </div>
                <span v-if="!classObj.hideSidebar" :title="children.name">{{ children.name }}</span>
              </template>
              <el-menu-item
                v-for="sub2 of children.sub"
                :key="sub2.path"
                :index="children.name + '/' + sub2.name"
                :title="sub2.name"
                style="min-width: 110px"
                @click="goNext(sub2)"
              >
                <img v-if="classObj.hideSidebar == true && queshow(sub2)" :src="sub2.icon2" alt="图片" class="activation" />
                <img v-else-if="sub2.icon1" :src="sub2.icon1" alt="图片" class="notActive" />
                <img v-else :src="noIcon" alt="图片" />
                <span v-if="!classObj.hideSidebar" class="w110">{{ sub2.name }}</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else :index="children.name" @click="goNext(children)">
              <div class="title_class">
                <img v-if="children.name != defaultactive.path && children.icon1" :src="children.icon1" alt="图片" class="notActive" onerror="children.icon1=''" />
                <img v-else-if="children.icon2" :src="children.icon2" alt="图片" onerror="children.icon2=''" class="activation" />
                <img v-else :src="noIcon" alt="图片" />
              </div>
              <span v-if="!classObj.hideSidebar" :title="children.name">{{ children.name }}</span>
            </el-menu-item>
          </div>
        </el-menu-item-group>
      </div>
    </el-menu>
    <div v-if="routeName === '个人' && !isCollapse && addDoc" class="dowmBut">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="addDepClassOpen">新增部门分类</el-button>
    </div>
    <el-dialog
      v-dialogDrag
      width="600px"
      :title="depClassTitle"
      top="50px"
      :visible.sync="depClassVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form ref="depClassForm" label-width="100px" :model="depClassForm" label-position="top" :rules="rules" size="small">
        <el-form-item label="分类名称" prop="deptCatalogue">
          <el-input ref="deptCatalogue" v-model.trim="depClassForm.deptCatalogue" maxlength="30" show-word-limit size="small" placeholder="请输入分类名称" />
        </el-form-item>
        <el-form-item label="关联部门" prop="deptIds">
          <el-cascader v-model="depClassForm.deptIds" style="width: 100%" size="small" :options="depOptions" :props="depDefaultProps" clearable> </el-cascader>
        </el-form-item>
        <el-form-item prop="allowSubDeptVisit">
          <el-checkbox v-model="depClassForm.allowSubDeptVisit" :true-label="1" :false-label="0" size="small"> 是否对子级部门人员进行数据开放 </el-checkbox>
        </el-form-item>
        <el-form-item label="文档管理员" prop="names">
          <el-input v-model="depClassForm.names" size="small" readonly>
            <template slot="append">
              <el-button size="small" @click="changePeople"> 选择文档管理员 </el-button>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="small" @click="closeDialog()"> 关闭 </el-button>
        <el-button type="primary" size="small" @click="submitEditdepClass()"> 确定 </el-button>
      </template>
    </el-dialog>
    <selectMembers :is-show.sync="membersChooseShow" :select-person-list="selectPersonList" :type="'文档管理员'" @change="toSelectMembers"> </selectMembers>
  </div>
</template>

<script>
const paramsForm = () => ({
  folderId: "",
  deptCatalogue: "",
  allowSubDeptVisit: 1,
  deptIds: [],
  managerUserIds: "",
  enterpriseId: "",
  names: ""
});
import { mapState } from "vuex";
import newService from "@/CommonDP/service/message-service";
import { getMenuList } from "@/CommonDP/utils/tree";
import org from "@/CommonDP/service/org-service";
import secondaryMenu from "@/CommonDP/service/secondaryMenu-service";
import selectMembers from "@/CommonDP/components/selectMembers";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
export default {
  name: "SecondaryMenu",
  components: {
    selectMembers
  },
  props: ["routeName", "isCollapse", "defaultactive", "classObj", "permissionKey", "projectType", "userRouterList", "externalShowList"],
  data() {
    const namesV = (rule, value, callback) => {
      if (this.depClassForm.names === "") {
        callback(new Error("文档管理员不能为空"));
      } else {
        callback();
      }
    };
    const deptCatalogueV = (rule, value, callback) => {
      var regExp = new RegExp('[\\\\|/:*<>?"]');
      if (value === "") {
        callback(new Error("请输入分类名称"));
      } else if (regExp.test(value)) {
        callback(new Error('分类名称不能包含以下字符:\\ / : * " ? < > |'));
      } else {
        callback();
      }
    };
    return {
      keyNew: 1,
      newShowList: [],
      depClassVisible: false,
      depClassTitle: "新增部门分类",
      rules: {
        deptCatalogue: [{ required: true, trigger: "blur", validator: deptCatalogueV }],
        deptIds: [{ required: true, message: "请选择关联部门", trigger: "change" }],
        names: [{ required: true, trigger: "change", validator: namesV }]
      },
      depClassForm: paramsForm(),
      noIcon: require("@/CommonDP/assets/noIcon.png"),
      argument: {
        folderId: "0",
        isRead: 1,
        priviAll: "1",
        enterpriseId: "",
        type: "",
        versionId: ""
      },
      depOptions: [],
      depDefaultProps: {
        children: "children",
        label: "deptName",
        value: "deptId",
        checkStrictly: true,
        multiple: true,
        emitPath: false,
        expandTrigger: "hover"
      },
      membersChooseShow: false,
      selectPersonList: [],
      delIcon: require("@/CommonDP/assets/doc/删除.png"),
      editIcon: require("@/CommonDP/assets/doc/编辑.png"),
      folder: require("@/CommonDP/assets/doc/文件夹.png"),
      addDoc: checkPermission(this.$allPerms.DOC_ADD),
      deleteDoc: checkPermission(this.$allPerms.DOC_DELETE),
      updateDoc: checkPermission(this.$allPerms.DOC_UPDATE)
    };
  },

  computed: {
    ...mapState({
      authRoutes: (state) => state.router.authRoutes,
      authProjectRoutes: (state) => state.router.authProjectRoutes,
      newsNumKey: (state) => state.router.newsNumKey,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      routerNav: (state) => state.router.routerNav
    }),

    showList() {
      if (this.externalShowList?.length) return this.externalShowList;
      const name = this.$route.matched[1]?.name || this.permissionKey;
      const meauList = this.authRoutes.find(({ permissionKey }) => permissionKey === name);
      let list = [];
      if (this.projectType) {
        list = this.projectList(this.authProjectRoutes);
      } else if (this.$route.meta.pname === "知识") {
        if (this.$route.matched[1]) list = this.projectList([meauList]);
      } else if (
        this.$route.meta.pname !== "用户中心" &&
        this.$route.name !== "catalogInit" &&
        this.$route.name !== "nopermisson" &&
        this.$route.name !== "noproject" &&
        this.$route.name !== "applicationAll" &&
        this.$route.name !== "application"
      ) {
        if (this.$route.matched[1]) {
          if (this.$route.matched[1].path === "/project") {
            if (meauList) list = this.projectList(this.authProjectRoutes);
          } else {
            if (meauList) list = this.projectList([meauList]);
          }
        }
      }
      console.log("list", list);
      return list;
    }
  },

  watch: {
    newsNumKey() {
      this.keyNew = ++this.keyNew;
      this.queryNewsNum();
    }
  },

  methods: {
    goNext(item) {
      this.$router.push(item.path);
    },

    async queryNewsNum() {
      if (this.$route.matched[1]) {
        var name = this.$route.matched[1].name ? this.$route.matched[1].name : this.permissionKey;
      }
      const meauList = this.authRoutes.find(({ permissionKey }) => permissionKey === name);
      const res = await newService.unreadlist(this.enterpriseId);
      if (meauList) {
        for (const key in meauList.childList) {
          meauList.childList[key].unReadNum = 0;
          res.data.map((item) => {
            if (meauList.childList[key].permissionName === "流程" && item.category === "2") {
              meauList.childList[key].unReadNum = item.unReadNum;
            } else if (meauList.childList[key].permissionName === "批注" && item.category === "1") {
              meauList.childList[key].unReadNum = item.unReadNum;
            } else if (meauList.childList[key].permissionName === "项目" && item.category === "0") {
              meauList.childList[key].unReadNum = item.unReadNum;
            } else if (meauList.childList[key].permissionName === "计划" && item.category === "4") {
              meauList.childList[key].unReadNum = item.unReadNum;
            } else if (meauList.childList[key].permissionName === "其他" && item.category === "3") {
              meauList.childList[key].unReadNum = item.unReadNum;
            }
          });
        }
        this.newShowList = this.projectList([meauList]);
      }
    },

    projectList(a) {
      const list = getMenuList(a) || [];
      if (list?.length && list[0].sub?.length) {
        list[0].sub = list[0].sub.filter(({ resourceType }) => resourceType === 0);
        return list;
      } else {
        return [];
      }
    },

    queshow(children) {
      for (var i = 0; i < children.sub.length; i++) {
        if (children.name + "/" + children.sub[i].name === this.defaultactive.path) {
          return true;
        }
      }
    },
    async addDepClassOpen() {
      this.depClassTitle = "新增部门分类";
      this.depClassVisible = true;
      this.selectPersonList = [];
      this.depClassForm = paramsForm();
      await this.$nextTick();
      if (this.depClassTitle === "新增部门分类") {
        this.$refs.deptCatalogue.focus();
      }
      this.$refs.depClassForm.clearValidate();
      this.queryDepList();
    },
    closeDialog() {
      this.depClassVisible = false;
    },
    submitEditdepClass() {
      this.$refs.depClassForm.validate(async (valid) => {
        if (valid) {
          this.depClassForm.enterpriseId = this.enterpriseId;
          if (this.depClassTitle === "新增部门分类") {
            await secondaryMenu.addEnterpriseDept(this.depClassForm);
            this.$message.success("添加成功");
          } else {
            await secondaryMenu.updateEnterpriseDept(this.depClassForm);
            this.$message.success("编辑成功");
          }
          this.depClassVisible = false;
          await this.$store.dispatch("setRouterNav", []);
          await this.$store.commit("saveFlatRoutes", []);
          await this.$store.dispatch("queryEnterpriseDept");
          this.$store.dispatch("GetModuleList", this.enterpriseId);
        } else {
          this.$message.success("请按照规则填写");
          return false;
        }
      });
    },
    async queryDepList() {
      const { data } = await org.getOrgTree(this.enterpriseId);
      if (data) {
        this.depOptions = this.getTreeData(data) || [];
      }
    },
    getTreeData(data) {
      for (var i = 0; i < data.length > 0; i++) {
        if (data[i].children == null || data[i].children.length <= 0) {
          data[i].children = undefined;
        } else {
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },
    toSelectMembers(data) {
      this.selectPersonList = data;
      this.depClassForm.managerUserIds = data.map((item) => {
        return item.userId;
      });
      this.depClassForm.names = data.map((ele) => ele.name).join(",");
    },
    changePeople() {
      this.membersChooseShow = true;
    },
    async delDepClass(val) {
      this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "el-message-box",
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(async () => {
          const folderId = val.permissionKey;
          await secondaryMenu.delEnterpriseDept(folderId);
          this.$message.success("删除成功");
          await this.$store.dispatch("setRouterNav", []);
          await this.$store.commit("saveFlatRoutes", []);
          await this.$store.dispatch("queryEnterpriseDept");
          await this.$store.dispatch("GetModuleList", this.enterpriseId);
          this.toPath();
        })
        .catch((res) => {
          console.log(res);
        });
    },
    async editDepClass(val) {
      this.depClassTitle = "编辑部门分类";
      this.depClassVisible = true;
      const folderId = val.permissionKey;
      this.depClassForm = paramsForm();
      await this.$nextTick();
      this.$refs.depClassForm.clearValidate();
      const { data } = await secondaryMenu.queryEnterpriseDeptEdit(folderId);
      this.depClassForm = { ...data };
      this.depClassForm.folderId = folderId;
      this.depClassForm.managerUserIds = data.userVoList.map((item) => {
        return item.userId;
      });
      this.depClassForm.names = data.userVoList.map((ele) => ele.name).join(",");
      this.selectPersonList = data.userVoList;
      this.queryDepList();
    },
    toPath() {
      const { path } = this.$route;
      const _isDepDoc = path.includes("/depDoc");
      if (_isDepDoc) {
        const bool = this.routerNav.some((item) => {
          return item.path === path;
        });
        // 判断当前路由还存在不存在 如果存在就按照当前的路由继续走 不存在就找第一个
        if (!bool) {
          if (this.routerNav.length) {
            this.$router.push({
              path: this.routerNav[0].path
            });
          } else {
            this.$router.push({
              path: "/doc"
            });
          }
        } else {
          this.$router.push({
            path: path
          });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/CommonDP/styles/mixin";
$--primary-light: mix($--color-white, $--color-primary, 92%);
.secondaryMenuContainer {
  font-size: 16px;
  height: 100%;
  .el-menu {
    height: 100%;
    overflow-y: hidden;

    &:hover {
      overflow-y: auto;
    }
  }
  // 子级
  .el-menu-item {
    overflow: hidden;
    height: 36px !important;
    line-height: 36px !important;
    padding-left: var(--small-space) !important;
    margin-bottom: var(--middle-space) !important;
    border-right: 2px solid $--color-white;
    span {
      font-size: 14px !important;
      width: 92px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .titleBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        margin-right: 5px;
      }
    }
  }
  // 父级
  /deep/ .el-submenu__title {
    height: 36px !important;
    line-height: 36px !important;
    padding-left: var(--small-space) !important;
    margin-bottom: var(--middle-space) !important;
    border-right: 2px solid $--color-white;
    span {
      font-size: 14px !important;
      width: 85px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  // 二级
  /deep/ .el-submenu .el-menu-item {
    padding-left: 30px !important;
    margin-bottom: var(--middle-space) !important;
  }

  // 悬浮
  /deep/ .el-menu-item:hover {
    background-color: $--primary-light !important;
    border-right: 2px solid $--color-primary;
  }
  /deep/ .el-submenu__title:hover {
    background-color: $--primary-light !important;
    border-right: 2px solid $--color-primary;
  }
  // 点击高亮
  .el-menu-item.is-active {
    // 高亮
    background: $--primary-light !important;
    color: $--color-primary;
    border-right: 2px solid $--color-primary;
  }

  .el-menu--collapse {
    width: 81px !important;
  }
  .title_class {
    width: 23px;
    height: 32px;
    display: inline-block;
    vertical-align: top;
    overflow: hidden;
    img {
      width: 20px;
      height: 20px;
      // margin-top: 2px;
      object-fit: scale-down;
    }
    img[src$="svg"].activation {
      filter: drop-shadow($--color-primary 100px -1px);
      transform: translateX(-100px);
    }
    img[src$="svg"].notActive {
      filter: drop-shadow(#666 100px -1px);
      transform: translateX(-100px);
    }
  }
  .newStyle {
    position: absolute;
    right: 15px;
    height: 30px;
    line-height: 30px;
    padding: 0px 8px;
    text-align: center;
    top: 3px;
    background: #f3f4f9;
    color: #324156;
    max-width: 48px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .dowmBut {
    width: 100%;
    position: absolute;
    bottom: 10px;
  }
  .enterpriseDeptDocName {
    width: 37px !important;
  }
  .w110 {
    width: 66px !important;
  }
  .docNav {
    height: calc(100% - 42px);
    overflow-x: hidden;
    border: none;
    /deep/ .el-submenu__title {
      span {
        font-weight: 700;
      }
    }
  }
  /deep/ .el-submenu__icon-arrow {
    right: 5px;
  }
}
</style>
